import {useEffect, useState} from "react";
import {createTheme, responsiveFontSizes, ThemeProvider} from "@material-ui/core/styles";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

export default function AppContainer(props) {

    const [theme, setTheme] = useState(createTheme());

    useEffect(() => {
        let updatedTheme = responsiveFontSizes(theme)
        setTheme(updatedTheme)
    }, []);

    return( <ThemeProvider theme={theme}>
        {props.children}
        </ThemeProvider>
     )

}